import { render, staticRenderFns } from "./topic-activity.vue?vue&type=template&id=00dca969&scoped=true&"
import script from "./topic-activity.vue?vue&type=script&lang=js&"
export * from "./topic-activity.vue?vue&type=script&lang=js&"
import style0 from "./topic-activity.vue?vue&type=style&index=0&id=00dca969&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00dca969",
  null
  
)

export default component.exports